import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const AuthBootstrap = ({ onBootstrapped, onCancel }) => {
  const [status, setStatus] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/bootstrap-status`, {
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error('Falha ao verificar bootstrap');
        }

        setStatus(await response.json());
      } catch (err) {
        setError(err.message || 'Erro ao carregar bootstrap');
      }
    };

    loadStatus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Confirmação de senha não confere');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/bootstrap`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, confirmPassword }),
      });

      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.message || 'Falha no bootstrap');
      }

      onBootstrapped(payload.user);
    } catch (err) {
      setError(err.message || 'Erro ao criar usuário inicial');
    } finally {
      setLoading(false);
    }
  };

  if (!status) {
    return <div className="auth-screen">Carregando bootstrap...</div>;
  }

  if (!status.allowed) {
    return (
      <div className="auth-screen">
        <h2>Bootstrap indisponível</h2>
        <p>Motivo: {status.reason}</p>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Voltar para login
        </button>
      </div>
    );
  }

  return (
    <div className="auth-screen">
      <h2>Bootstrap inicial</h2>
      <p>Crie o primeiro usuário administrador do cockpit.</p>
      <form onSubmit={handleSubmit} className="execution-form">
        <div className="form-group">
          <label className="form-label" htmlFor="bootstrap-username">Usuário</label>
          <input id="bootstrap-username" className="form-input" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="bootstrap-password">Senha</label>
          <input id="bootstrap-password" type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="bootstrap-confirm-password">Confirmar senha</label>
          <input id="bootstrap-confirm-password" type="password" className="form-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Criando...' : 'Criar primeiro usuário'}
        </button>
      </form>
    </div>
  );
};

export default AuthBootstrap;
